// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.added-business-modal-modal_card-k5UEA {
  width: 340px;
  height: auto;
}

.added-business-modal-item-I3VXg {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.added-business-modal-itemTitle-_7npn {
  font-size: 14px;
  color: var(--color-neutral-800);
}
  
.added-business-modal-itemValue-gCV4v {
  font-size: 16px;
  color: var(--color-neutral-900);
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/added-business-modal/added-business-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.itemTitle {\n  font-size: 14px;\n  color: var(--color-neutral-800);\n}\n  \n.itemValue {\n  font-size: 16px;\n  color: var(--color-neutral-900);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `added-business-modal-modal_card-k5UEA`,
	"item": `added-business-modal-item-I3VXg`,
	"itemTitle": `added-business-modal-itemTitle-_7npn`,
	"itemValue": `added-business-modal-itemValue-gCV4v`
};
export default ___CSS_LOADER_EXPORT___;
